








































import Vue from 'vue';
import Charts from '@/components/widgets/Charts.vue';
import OrganizationUserProfile from '@/views/authenticated/OrganizationUserProfile.vue';
import OrganizationPeerGroupProfile from '@/views/authenticated/OrganizationPeerGroupProfile.vue';

export default Vue.extend({
  components: {
    Charts,
    OrganizationPeerGroupProfile,
    OrganizationUserProfile
  },

  props: {
    left: {
      type: Object
    },
    chartUserId: { type: Number },
    chartPeerGroupId: { type: Number },
    chartOrganizationId: { type: Number }
  },

  data() {
    return {
      tab: null
    };
  },

  computed: {
    split(): boolean {
      return this.$vuetify.breakpoint.lgAndUp;
    },

    fixedLeftNav(): boolean {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    showLeft(): boolean {
      return !this.split && this.tab == 0;
    },

    showRight(): boolean {
      return !this.split && this.tab == 1;
    }
  }
});
